/**
 * Vendor program header block for video
 */
import React, { Component } from 'react';
import withStyles from '@mui/styles/withStyles';
import { Grid, Typography } from '@mui/material';

const styleSheet = theme => ({
    root: {
        flexGrow: 1,
    },
    link:  {
      color: 'blue'
    }
  
});

class VendorPartnerProgramBlockVideo extends Component {

  render() {

    const classes = this.props.classes;

    let videoAssets = [];

    let i = 0;
    for (i = 0; i < this.props.assets.length; i++) {
      let asset = this.props.assets[i];
      if (asset.assetType === 3) {
        videoAssets.push(asset);
      }
    }

    // Counter for unique keys
    let counter = 0;
    
    return (
      <Grid container spacing={2}  justifyContent="center" alignItems="center">

        {videoAssets.length > 0 &&


        <React.Fragment>
          
          <Grid item>
            { videoAssets.map(link => {
              
                return (
                
                  <iframe width="400" height="225" src={link.assetLink} title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
                )
            })}
              
          </Grid>
        </React.Fragment>}
      </Grid>
    );
  }
}
  
export default withStyles(styleSheet)(VendorPartnerProgramBlockVideo);